const DIFFERENT_SESSION_START_TIME = 'differentSessionStartTime';
export default DIFFERENT_SESSION_START_TIME;
